import React from 'react'
import get from 'lodash/get'
import styled, { css } from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import { Typography } from 'components'
import ClasswinEditor from 'components/classwinEditor/loadable'
import { useWindowSize } from 'react-use'

const Container = styled.div`
  width: 100%;
  margin-bottom: 30px;
`
const ShowLess = styled.div`
  width: 100%;
  padding: 15px 0px;
  margin: 0px 0 35px;
  border: 1px solid #ccc;
  border-radius: 6px;
  ${({ borderless }) => {
    if (borderless)
      return css`
        border: none;
        padding: 0;
        .ql-editor {
          padding: 0 0 12px;
        }
      `
    return css``
  }}
  .ql-editor {
    ul {
      padding-left: 0;
    }
  }
  .quill {
    &.show-less::after {
      display: block;
      position: relative;
      /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000 100%); */
      margin-top: -150px;
      height: 150px;
      width: 100%;
      content: '';
    }
  }
  .show-less .ql-container .ql-editor {
    max-height: 180px;
  }
  @media (max-width: 768px) {
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
`

const paddingTop = 5

const Description = (props) => {
  const { description } = props
  const { width } = useWindowSize()
  const formattedDesc = description
    ? description
    : JSON.stringify({ content: '', delta: { ops: [] } })
  const courseDes = {
    delta: {
      ops: [...get(JSON.parse(formattedDesc), 'delta.ops', [])],
    },
  }

  return (
    <ErrorBoundary>
      <Container>
        <Typography
          color="primary1"
          fontSize={width <= 425 ? 'text-sm' : 'text-sm'}
          bold
          id="label.desc"
        >
          Description
        </Typography>
        <ShowLess borderless>
          <ClasswinEditor
            isShowAll={false}
            min={2}
            readOnly
            value={JSON.stringify(courseDes)}
            padding={`${paddingTop}px 0 0 0`}
            fontSize={width <= 425 ? 'text-sm' : 'text-sm'}
            color="#253e87"
            bulletPadding={0}
            editorMaxHeight={150}
            buttonStyles={{
              color: '#253e87',
              border: 'none',
              fontSize: width <= 425 ? 12 : 14,
              fontWeight: 700,
              iconSize: 24,
            }}
            calLineParams={{ subtract: paddingTop, lineHeight: 24 }}
          />
        </ShowLess>
      </Container>
    </ErrorBoundary>
  )
}

export default Description
